
const DateUtils = {
    formatDisplay: "DD/MM/YYYY",
    formatServer: "YYYY-MM-DDTHH:mm:SS.SSSZ",
}

export default DateUtils;
